<template>
  <div class="main-page-wrapper overflow-hidden">
    <Header />
    <Slide :img="domainObject.imgBackground" :textH3="domainObject.title" :fondHeroBlue="true" :w100="true" />
    <div class="position-relative overflow-hidden">
      <Breadcrumb :level1="`Domaines`" :level2="domainObject.title" level3=""/>
      <img class="bg-filets" src="/images/altela-img/nos-domaines/bg-filets.png" />
      <div class="infoDomaine d-flex">
        <div class="icon w-50">
          <img :src="domainObject.icon" :alt="domainObject.title" class="m-auto">
        </div>
        <div class="textDomaine">
          <div class="title mb-3">
            {{ domainObject.title }}
          </div>
          <div class="describe mb-3" v-html="domainObject.describe"></div>
          <div class="btnAllDomaine">
            <NuxtLink to="#nos-domaines" class="btnDecouvrir">
              Voir tous nos domaines <i class="ms-3 fa-solid fa-arrow-right-long"></i>
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>
    <div class="menuDomain">
      <SubMenu :menu="1" v-if="activeMenu1" color="#D9000D" class="mb-50"/>
      <SubMenu :menu="2" v-if="activeMenu2" color="#093888" class="mb-50"/>
      <SubMenu :menu="3" v-if="activeMenu3" color="#118D16" class="mb-50"/>
      <SubMenu :menu="4" v-if="activeMenu4" color="#318CE7" class="mb-50"/>
      <SubMenu :menu="5" v-if="activeMenu5" color="#D8922A" class="mb-50"/>
      <SubMenu :menu="6" v-if="activeMenu6" color="#000" class="mb-50"/>
      <SubMenu :menu="7" v-if="activeMenu7" color="#6B9AAF" class="mb-50"/>
    </div>
    <NosDomaines title="Tous nos domaines" />
    <Footer />
  </div>
</template>

<script setup lang="ts">
import Header from "~/components/altela/Header/index.vue";
import Footer from "~/components/altela/Footer/index.vue";
import domaines from "@/public/static/nos-domaines.json"
import Slide from "~/components/altela/Slide/index.vue";
import Breadcrumb from "~/components/altela/Breadcrumb/index.vue";
import SubMenu from "~/components/altela/SubMenu/index.vue";
import NosDomaines from "~/components/altela/NosDomaines/index.vue";

const route = useRoute()
const domainObject = domaines.filter(elm => elm.id === parseInt(route.params.idSlug as string))[0]

const activeMenu1 = computed(() => false)
const activeMenu2 = computed(() => {
  return route.params.idSlug === '3'
})
const activeMenu3 = computed(() => {
  return route.params.idSlug === '3' || route.params.idSlug === '4'
})
const activeMenu4 = computed(() => {
  return route.params.idSlug === '6'
})
const activeMenu5 = computed(() => {
  return route.params.idSlug === '1'
})
const activeMenu6 = computed(() => {
  return route.params.idSlug === '6' || route.params.idSlug === '3' || route.params.idSlug === '4' || route.params.idSlug === '1'
})
const activeMenu7 = computed(() => {
  return route.params.idSlug === '4' || route.params.idSlug === '1'
})
</script>

<style scoped>
.bg-filets {
  position: absolute;
  top: -150%;
  opacity: 0.1;
  width: 100%;
  height: auto;
  object-fit: cover;
  z-index: -1;
}

.infoDomaine {
  padding: 0 140px;
  margin-top: 3rem;
}

.menuDomain {
  padding: 0 140px;
  margin-top: 8rem;
}

.btnDecouvrir {
  padding: 12px 25px;
  background: #D9000D;
  color: #fff;
  width: auto;
  font-size: 18px;
  text-transform: uppercase;
  border-radius: 5px;
  cursor: pointer;
}

.btnDecouvrir:hover {
  background: #003853;
}

.title {
  font-family: Panton, sans-serif;
  font-size: 2.0625rem;
  font-style: italic;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: 0.0325rem;
  text-transform: uppercase;
  color: #003853;
}

.describe {
  color: #003853;
}

@media screen and (max-width: 768px) {
  .infoDomaine {
    padding: 1rem;
    flex-direction: column;
    align-items: center;
  }

  .textDomaine .title,
  .btnAllDomaine {
    text-align: center;
  }

  .textDomaine .describe {
    text-align: justify;
  }

  .menuDomain {
    padding: 1rem;
    margin-top: 3rem;
  }
}
</style>